export class UploadApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Request a presigned S3 POST URL with form fields.
     */
    async requestUpload(params) {
        return this.client.post('/api/uploads/request', params);
    }
    /**
     * Notify the server that a file upload is complete.
     */
    async completeUpload(mediaId) {
        return this.client.post(`/api/uploads/${encodeURIComponent(mediaId)}/complete`, {});
    }
    /**
     * Check the processing status of an upload.
     */
    async getStatus(mediaId) {
        return this.client.get(`/api/uploads/${encodeURIComponent(mediaId)}/status`);
    }
}
//# sourceMappingURL=upload-api.js.map